 <script src="https://www.google.com/recaptcha/api.js"></script>

<template>
  <div class="p-0 container-fluid">
    <div class="g-0 row">
      <div class="col-xl-9">
        <div class="auth-full-bg pt-lg-5 p-4">
          <div class="w-100">
            <div class="bg-overlay"></div>
          </div>
        </div>
      </div>

      <div class="col-xl-3">
        <div class="auth-full-page-content p-md-5 p-4">
          <div class="w-100">
            <div class="d-flex flex-column h-100">
              <div class="mb-4 mb-md-5">
                <img src="https://unicampo.coop.br/uploads/bkp/2022/portal/logo.png" height="45" />
              </div>
              <div class="my-auto">
                <div>
                  <div>
                    <h5 class="text-primary">Bem-Vindo(a)!</h5>
                    <p class="text-muted">
                      Entre para utilizar o Portal Unicampo
                    </p>
                  </div>

                  <div v-if="alerta" class="m-auto">
                    <b-alert show :variant="variante" v-if="!showAlertEmail">
                      {{ mensagem }}
                    </b-alert>

                    <b-alert show variant="danger" v-else>
                      {{ mensagem }}
                      <div v-if="showAlertToken">
                        <br /><br />
                        Caso não tenha recebido o e-mail,
                        <router-link to="/reenvioEmail" variant="link" class="p-0">
                          Clique aqui
                        </router-link>
                        para receber uma nova confirmação no e-mail.
                      </div>
                    </b-alert>
                  </div>

                  <!-- FORMULÁRIO DE LOGIN -->
                  <form @keyup.enter="submit" @submit.prevent="submit">
                    <div class="mb-3">
                      <emailCpf label="Email ou CPF" inputText="Digite um e-mail ou CPF"
                        inputInvalid="Digite um e-mail ou CPF válido" :validado="verificaEmailCpf"
                        v-on:emitindoEmailCpf="atribuiEmailCpf" tabindex="1" />
                    </div>
                    <div class="mb-2">
                      <div class="float-end">
                        <a class="text-muted div-clickable" tabindex="-1" @click="showModal = true">Esqueceu a
                          senha?</a>
                      </div>
                    </div>

                    <div class="mb-3">
                      <senha label="Senha" inputText="Digite uma senha" inputInvalid="Digite um senha válida"
                        :mostraSenha="true" :validado="verificaPassword" v-on:emitindoSenha="atribuiSenha"
                        tabindex="1" />
                    </div>
                    <vue-recaptcha ref="recaptcha" size="invisible" @verify="verifyMethod"
                      sitekey="6LebGvweAAAAAFnTI7kT4HBEvkfpo-mDg-Ndfq2D">
                    </vue-recaptcha>

                    <div class="mt-3 d-grid">
                      <button class="btn btn-primary btn-block" type="submit">
                        Entrar
                      </button>
                    </div>
                  </form>

                  <div class="mt-3 text-center">
                    <p>
                      Não tem acesso?
                      <router-link to="/cadastrocandidato">
                        <a href="/cadastrocandidato" class="fw-medium text-primary" target="_blank">
                          Cadastre-se aqui</a>
                      </router-link>
                    </p>
                  </div>
                </div>
                <div class="mt-4 text-center">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a class="social-list-item bg-primary text-white border-primary"
                        href="https://pt-br.facebook.com/UNICAMPO/" target="_blank">
                        <i class="mdi mdi-facebook"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a class="social-list-item bg-danger bg-gradient text-white border-danger"
                        href="https://www.instagram.com/unicampo_coop" target="_blank">
                        <i class="mdi mdi-instagram"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a class="social-list-item bg-info text-white border-info"
                        href="https://br.linkedin.com/company/unicampo" target="_blank">
                        <i class="mdi mdi-linkedin"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a class="social-list-item bg-danger text-white border-danger"
                        href="https://www.youtube.com/channel/UCiskgZkQPOzT6i4AdY0JbAw" target="_blank">
                        <i class="mdi mdi-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="mt-4 mt-md-5 text-center">
                <p class="mb-0">
                  © {{ new Date().getFullYear() }} UNICAMPO. Todos os direitos
                  Reservados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template>
      <b-modal v-model="showModal" title="Esqueceu a senha?" size="lg">
        <div class="row">
          <div class="col-12">
            <label style="size: 18px; text-align: center">Para redefinir a sua senha, informe o seu e-mail no campo
              abaixo.
              Enviaremos um e-mail com link de redefinição de senha.</label>
          </div>
          <div class="col-12">
            <emailCpf label="E-mail" inputText="Digite um e-mail" inputInvalid="Digite um e-mail válido"
              :validado="null" v-on:emitindoEmailCpf="atribuiEmailCpf" tabindex="1" ref="componentEmail" />
          </div>
          <div class="col-12">
            <label class="mt-2" style="size: 18px">Se precisar de ajuda, entre em contato:</label>
            <div style="size: 18px">Telefone: (44) 4009-3800</div>
            <div style="size: 18px">Email: unicampo@unicampo.coop.br</div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="danger" @click="showModal = false">Cancelar</b-button>
          <b-button variant="success" @click="enviarEmailRedefinirSenha()" :disabled="loading">
            Enviar
            <b-spinner small class="ms-2" v-if="loading"></b-spinner>
          </b-button>
        </template>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { VueRecaptcha } from "vue-recaptcha";
import emailCpf from "@/components/formulario/emailCpf-input";
import senha from "@/components/formulario/senha-input";
//import CryptoJS from "crypto-js";
import { required } from "vuelidate/lib/validators";

export default {
  components: { emailCpf, senha, VueRecaptcha },
  layout: "empty",
  data() {
    return {
      auth: {
        email: "",
        cpf: "",
        password: "",
      },
      emailRedefinir: "",
      submitted: false,
      alerta: false,
      mensagem: null,
      verificaEmailCpf: null,
      verificaPassword: null,
      showModal: false,
      loading: false,
      showAlertEmail: false,
      showAlertToken: false,
      showValidaEmail: true,
    };
  },

  created() {
    this.$tools.getIp();
    this.$tools.abrirMenu();
    if (this.$store.state.access_token) {
      this.$router.push("/");
    } else if (this.$route.path != "/login") {
      this.$router.push("/login");
    }
  },

  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          window.latLng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        },
        function (error) {
          alert(
            "Erro ao obter localização! Para nos ajudar e melhorar o sistema habilite a localização"
          );
          console.log("Erro ao obter localização.", error);
        }
      );
    } else {
      console.log("Navegador não suporta Geolocalização!");
    }
  },

  validations: {
    auth: {
      password: {
        required,
      },
    },
  },

  methods: {
    atribuiSenha(senha) {
      this.auth.password = senha;
    },

    atribuiEmailCpf(emailCpf) {
      var verificaNumero = emailCpf.replace(/\W/g, "");
      if (isNaN(verificaNumero) === true) {
        this.auth.email = emailCpf;
        this.auth.cpf = "";
      } else {
        this.auth.cpf = emailCpf;
        this.auth.email = "";
      }
      this.emailRedefinir = emailCpf;
    },

    login() {
      this.submitted = true;
      this.$v.$touch();

      if (!this.$v.$invalid) {
        // Criptografa a senha antes de enviar
        // const CryptoJS = require("crypto-js");

        // // Gera um IV aleatório de 16 bytes
        // const iv = CryptoJS.lib.WordArray.random(16);

        // // Criptografa usando o IV e a chave definida
        // const encrypted = CryptoJS.AES.encrypt(this.auth.password, CryptoJS.enc.Utf8.parse(process.env.VUE_APP_PASSWORD_STRING), {
        //     iv: iv,
        //     mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        // });

        // // Combina o IV e o texto criptografado em uma única string (formato base64)
        // const encryptedPassword = CryptoJS.enc.Base64.stringify(iv.concat(encrypted.ciphertext));

        // const authPayload = {
        //   email: this.auth.email,
        //   cpf: this.auth.cpf,
        //   password: encryptedPassword,
        // };

        this.$store
          .dispatch("login", this.auth)
          .then(async () => {
            this.submitted = false;

            await Promise.all([
              this.verificaDocumentoJuridico(),
              this.verificaDocumentoAssembleia(),
              this.verificarPendenciaAssinaturaEletronica(),
              // this.verificarInfoBancaria(),
              this.verificarEsocial(),
              this.verificaTelEmergencia(),
            ]);

            //Descomentar para passar direto pelas validações
            // this.$store.commit("VALIDA_TERMO_LGPD", true);
            // this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
            // this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
            // this.$store.commit("VALIDA_ESOCIAL", true);
            // this.$store.commit("TEL_EMERGENCIA", true);
            this.$router.push("/");
          })
          .catch((err) => {
            this.alerta = true;
            this.variante = "danger";
            this.showAlertEmail = true;
            this.showAlertToken = false;
            this.$refs.recaptcha.reset();
            if (err.response.status == 422) {
              this.mensagem = err.response.data.email;
              this.verificaEmailCpf = false;
            } else if (err.response.status == 404) {
              this.mensagem = err.response.data.message;
              this.showAlertEmail = true;
              this.showAlertToken = true;
            } else {
              this.mensagem = err.response.data.message;
              this.showAlertEmail = true;
              this.verificaPassword = false;
            }
          });
      } else {
        this.alerta = true;
        this.variante = "danger";
        this.mensagem = "Preencha todos os campos abaixo para continuar";
        this.verificaEmailCpf = false;
        this.verificaPassword = false;
      }
    },

    submit() {
        if (this.$http.defaults.baseURL == "https://portal-api.unicampo.coop.br/") {
          this.$refs.recaptcha.execute();
        } else {
          this.login();
        }
    },

    verifyMethod(token) {
      this.$http
        .get("api/auth/recaptcha/" + token)
        .then((response) => {
          if (response.data.success) {
            this.login();
          } else {
            this.$tools.alerta("Recaptcha Invalido", "error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async verificaDocumentoJuridico() {
      const user = this.$store.state.me;

      await this.$http
      .get("api/lgpd/verificarTermoConsentimento/" + user.nr_docto)
      .then((response) => {
        //Verifica se exite documento assinado (===1), se sim, ele continua o fluxo normal, se não, ele redireciona para a tela de assinatura
        if (response.data.ExisteDocumento == 1) {
          this.$store.commit("VALIDA_TERMO_LGPD", true);
        } else {
          this.$store.commit("VALIDA_TERMO_LGPD", false);
          // this.$router.push("/termo/lgpd");
        }
        // await this.verificaDocumentoAssembleia();
      })
      .catch(() => {
        this.$store.commit("VALIDA_TERMO_LGPD", true);
        // this.$router.push("/");
      });
    },

    async verificaDocumentoAssembleia() {
      await this.$http
      .get("api/reuniao/verificarTermo")
      .then((response) => {
        const sq_upload = response.data.sq_upload;
        //Verifica se existe termo da assembleia (AGO, AGE) a ser assinado, se não existe, ele continua o fluxo normal, se existe, ele redireciona para a tela de assinatura
        if (sq_upload) {
          this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", false);
          this.$store.commit("TERMO_ASSEMBLEIA", sq_upload);
          // this.$router.push("/termo/assembleia/" + sq_upload);
        } else {
          this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
        }
        // await this.verificarPendenciaAssinaturaEletronica();
      })
      .catch(() => {
        this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
        // this.$router.push("/");
      });
    },

    async verificarPendenciaAssinaturaEletronica() {
      await this.$http
      .get("api/assinaturaEletronica/verificarPendenciaAssinaturaEletronica")
      .then((response) => {
        //Verifica se existe documento a ser assinado, se não existe, ele continua o fluxo normal, se existe, ele redireciona para a tela de assinatura
        if (response.data.length > 0) {
          if (
            response.data[0].TIPOPENDENCIA === "S" &&
            response.data[0].SQUPLOADPENDENCIA !== null
          ) {
            this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", false);
            // this.$router.push("/assinaturaEletronica");
          } else {
            this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
            // this.$router.push("/");
          }
        } else {
          this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
          // this.$router.push("/");
        }
      })
      .catch(() => {
        this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
        // this.$router.push("/");
      });
    },

    async verificarInfoBancaria(){
      try {
        const respSituacao = await this.$http.get(
          "api/cadastroCandidato/verificaInfoBancaria"
        );

        if (respSituacao.status === 200) {
          this.$store.commit("INFO_BANCARIA", false);
          localStorage.setItem("validacao-info-bancaria", 'false');
        } else {
          this.$store.commit("INFO_BANCARIA", true);
        }
      } catch (error) {
        const infoBancariaFlag = localStorage.getItem("validacao-info-bancaria");

        if (error.response && error.response.status === 403 && !infoBancariaFlag) {
          this.$store.commit("INFO_BANCARIA", true);
        }
      }
    },

    async verificarEsocial(){
      await this.$http
      .get("api/cadastroCandidato/atualizaRacaCor")
      .then((response) => {

        if(response.data.status){
          this.$store.commit("VALIDA_ESOCIAL", true);
        }

      })
      .catch(() => {
        this.$store.commit("VALIDA_ESOCIAL", true);
      });
    },

    async verificaTelEmergencia(){
      try {
        const respData = await this.$http.get("api/cadastroCandidato/consultaContatos");

        if (respData.data.status == 500) {
          this.$store.commit("TEL_EMERGENCIA", true);
        }

        this.dadosCadastrais    = respData.data.dados;
        const telEmergenciaFlag = localStorage.getItem("validacao-tel-recados");

        if (respData.data.validacao === 'V' && !telEmergenciaFlag || respData.data.status == 500) {
          this.$store.commit("TEL_EMERGENCIA", true);
        } else {
          this.$store.commit("TEL_EMERGENCIA", false);
          localStorage.setItem("validacao-tel-recados", 'false');
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error === "Nenhum registro encontrado") {
          this.$store.commit("TEL_EMERGENCIA", true);
        } else {
          console.error("Erro ao consultar contatos:", error);
        }
      }
    },

    enviarEmailRedefinirSenha() {
      this.loading = true;
      const email = this.auth.email?.trim();

      if (!email) {
        this.$tools.alerta("O campo de e-mail não pode estar vazio.", "warning");
        this.loading = false;
        return;
      }

      if (!this.$refs.componentEmail.validaCampo()) {
        return;
      }

      this.$http
        .get("api/auth/enviarEmailRedefinirSenha/" + this.auth.email)
        .then((response) => {
        this.$tools.alerta(
        "Você receberá um e-mail com link de redefinição de senha em até 24 horas. Verifique sua caixa de entrada.",
        "success"
      );
      this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        this.$tools.alerta(err.response.data.message, "error");
      });
    },
  },
};
</script>
